import { IStyle } from '@fluentui/react';
import { IH2OTheme } from '@h2oai/ui-kit';

export interface IAccessControlStyles {
  root?: IStyle;
  header?: IStyle;
}

export interface IAccessControlClassNames {
  root: string;
  header: string;
}

export const accessControlStylesDefault = (_theme: IH2OTheme): Partial<IAccessControlStyles> => ({
  root: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    minHeight: 0,
  },
  header: {},
});
